/* Hot Buy List — henter /apps/portal/hotbuy (App Proxy, ingen auth) og
   renderer sektions-panelerne. Credit-pillen er helten.
   Fail-soft: inaktiv liste, tom liste eller netværksfejl => pæn fallback
   med CTA til /pages/saelg — aldrig en død side. ES5. */
(function () {
  'use strict';

  var rod = document.querySelector('[data-mtw-hotbuy]');
  if (!rod) return;

  var liste = rod.querySelector('[data-mtw-hb-liste]');
  var gyldigEl = rod.querySelector('[data-mtw-hb-gyldig]');
  if (!liste) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Kun http(s)-URL'er slipper igennem til src-attributter */
  function sikkerUrl(u) {
    if (typeof u !== 'string') return '';
    if (u.indexOf('https://') === 0 || u.indexOf('http://') === 0) return esc(u);
    return '';
  }

  var CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 12.5l4.5 4.5L19.5 6.5" fill="none" stroke="#1a1a1a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var FLAMME_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12.6 2.6c.5 2.6-1.4 4-1 6 .3 1.4 1.3 2.1 2.1 2.4.1-1.1.6-2.1 1.5-2.9 1.9 1.7 3.3 4 3.3 6.6 0 4-2.9 6.8-6.5 6.8S5.5 18.7 5.5 14.7c0-3.3 2.3-5.7 3.9-7.6 1.2-1.4 2.4-2.8 3.2-4.5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/></svg>';

  function visFallback() {
    if (gyldigEl) gyldigEl.hidden = true;
    liste.innerHTML =
      '<div class="mtw-hb__fallback">' +
      FLAMME_SVG +
      '<h2>Hot Buy List’en er ved at blive opdateret</h2>' +
      '<p>Kig forbi igen snart — vi køber stadig, og kurserne er på vej op igen.</p>' +
      '<a class="mtw-hb__knap" href="/pages/saelg">Sælg din samling</a>' +
      '</div>';
  }

  function renderBetingelser(betingelser) {
    if (!betingelser || typeof betingelser !== 'string') return '';
    var dele = betingelser.split('·');
    var html = '';
    var i;
    var t;
    for (i = 0; i < dele.length; i++) {
      t = dele[i].replace(/^\s+|\s+$/g, '');
      if (!t) continue;
      html += '<span class="mtw-hb__betingelse">' + CHECK_SVG + esc(t) + '</span>';
    }
    return html ? '<div class="mtw-hb__betingelser">' + html + '</div>' : '';
  }

  function renderVifte(kort) {
    if (!kort || !kort.length) return '';
    var maks = Math.min(kort.length, 4);
    var html = '';
    var i;
    var url;
    for (i = 0; i < maks; i++) {
      url = kort[i] && sikkerUrl(kort[i].billede);
      if (!url) continue;
      html +=
        '<img class="mtw-hb__kort" src="' + url + '" alt="' + esc(kort[i].navn || '') + '" decoding="async" onerror="this.parentNode.removeChild(this)">';
    }
    if (!html) return '';
    return '<div class="mtw-hb__vifte mtw-hb__vifte--n' + maks + '">' + html + '</div>';
  }

  function pct(n, fallback) {
    n = Number(n);
    if (!isFinite(n) || n <= 0) n = fallback;
    return Math.round(n);
  }

  function renderSektion(s) {
    var kontant = pct(s.kontant_pct, 80);
    var credit = pct(s.credit_pct, 90);
    var logo = sikkerUrl(s.logo);

    var hoved = '<header class="mtw-hb__s-hoved">';
    if (logo) {
      hoved += '<img class="mtw-hb__s-logo" src="' + logo + '" alt="' + esc(s.titel || '') + '" decoding="async" onerror="this.parentNode.removeChild(this)">';
    } else {
      hoved += '<h2 class="mtw-hb__s-titel">' + esc(s.titel || '') + '</h2>';
    }
    if (s.undertitel) hoved += '<div><span class="mtw-hb__s-under">' + esc(s.undertitel) + '</span></div>';
    hoved += '</header>';

    return (
      '<article class="mtw-hb__sektion">' +
      hoved +
      renderVifte(s.kort) +
      '<div class="mtw-hb__procenter">' +
      '<div class="mtw-hb__procent mtw-hb__procent--kontant"><b>' + kontant + ' %</b><span>Kontant</span></div>' +
      '<div class="mtw-hb__procent mtw-hb__procent--credit"><span class="mtw-hb__procent-badge">Mest værdi</span><b>' + credit + ' %</b><span>Store Credit</span></div>' +
      '</div>' +
      renderBetingelser(s.betingelser) +
      '</article>'
    );
  }

  function render(data) {
    if (!data || data.aktiv === false || !data.sektioner || !data.sektioner.length) {
      visFallback();
      return;
    }
    if (gyldigEl) {
      if (data.gyldig) {
        gyldigEl.textContent = data.gyldig;
        gyldigEl.hidden = false;
      } else {
        gyldigEl.hidden = true;
      }
    }
    var html = '';
    var i;
    for (i = 0; i < data.sektioner.length; i++) {
      html += renderSektion(data.sektioner[i] || {});
    }
    liste.innerHTML = html;
  }

  fetch('/apps/portal/hotbuy', { headers: { 'Accept': 'application/json' } })
    .then(function (res) {
      if (!res.ok) throw new Error('http ' + res.status);
      return res.json();
    })
    .then(render)
    .catch(function () {
      visFallback();
    });
})();
